import React from 'react'
import { Box, Grid, Button, Typography } from "@mui/material";
import { ToggleStyle } from './style';
import { Label } from '../label'


export const ToggleBtn = ({
    options = [],
    spacing = 0,
    divider = {
        xs: 2.5,
        sm: 2.5,
        md: 2.5,
        lg: 2.5,
    },
    onChange = () => false,
    value = "",
    padding = "15px 12px",
    borderRadius = null,
    border = null,
    backgroundColor = null,
    label = null,
    isrequired = false,
    backgroundColorunparent = null,
    fontSize = "14px",
    width = null,
    backgroundColorunselected=null
}) => {
    const { xs, sm, md, lg } = divider
    const language = localStorage.getItem("i18nextLng")
    return (
        <div>
            {label && <Label label={label} isRequired={isrequired} />}
            <Box sx={language === "ar" ? ToggleStyle({ backgroundColorunparent , backgroundColorunselected})?.parentArabic : ToggleStyle({ backgroundColorunparent , backgroundColorunselected})?.parent} >
                <Grid container sx={ToggleStyle?.grid}>
                    {
                        options?.map((val, index) => {
                            return (
                                <Grid item xs={xs} sm={sm} md={md} lg={lg} key={index}
                                    sx={{ paddingTop: '0px !important' }}>
                                    <Button onClick={() => onChange(val?.value)} variant={"contained"}
                                        sx={value === val?.value ? ToggleStyle({ padding, borderRadius, border, backgroundColor, fontSize, width ,backgroundColorunselected})?.selected : ToggleStyle({ padding, borderRadius, border, backgroundColor, fontSize, width,backgroundColorunselected })?.unselected} fullWidth>
                                        <Typography noWrap sx={{ fontSize: "0.75rem !important" }}>{val?.label}</Typography>
                                    </Button>
                                </Grid>
                            )
                        })
                    }

                </Grid>
            </Box>
        </div>
    )
}
